import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper-relative" }
const _hoisted_2 = { class: "wrapper-absolute" }
const _hoisted_3 = { class: "wrapper-fixed" }
const _hoisted_4 = {
  class: "title",
  ref: "home"
}
const _hoisted_5 = { class: "main-menu" }
const _hoisted_6 = {
  class: "menu",
  ref: "menu"
}
const _hoisted_7 = { class: "menu-toogle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Hugo Cohen", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ], 512),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "main-menu-item",
                onClick: _ctx.toggle,
                to: "/photo"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Photo", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "main-menu-item",
                onClick: _ctx.toggle,
                to: "/video"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Video", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "main-menu-item",
                onClick: _ctx.toggle,
                to: "/about"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("About", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.toggleMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.menuIcons.bars,
                    onClick: _ctx.toggle
                  }, null, 8, ["icon", "onClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.menuIcons.cross,
                    onClick: _ctx.toggle
                  }, null, 8, ["icon", "onClick"])
                ]))
          ])
        ])
      ])
    ])
  ]))
}